import { createSagasForBasicCall } from "core/sagas";
import { actions } from "./actions";


































export default [
    ...createSagasForBasicCall(actions),
    
    
];
